import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/components/Dashboard.vue'
import Login from '@/components/Login.vue'
import User from '@/components/User.vue'
import Product from '@/components/Product.vue'
import Order from '@/components/Order.vue'
import NewOrder from '@/components/NewOrder.vue'
import OrderDetail from '@/components/OrderDetail.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
     meta: { title: "Dashboard", public: false, private: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/users',
    name: 'User',
    component: User,
    meta: { title: "Customers", public: false, private: true }
  },
  {
    path: '/products',
    name: 'Product',
    component: Product,
    meta: { title: "Products" }
  },
  {
    path: '/orders',
    name: 'Order',
    component: Order,
    meta: { title: "Orders" }
  },
  {
    path: '/neworder',
    name: 'New Order',
    component: NewOrder,
    meta: { title: "New Order" }
  },
  {
    path: '/order/:id?',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: { title: "Order Detail" }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
